
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  height: 100%;
}

.card {
  height: 100%;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 0.375rem;
  padding: 1.5rem;
  padding-bottom: 0.5rem;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

@media (min-width: 480px) {

  .card {
    flex-direction: row;
  }

  .card {
    align-items: flex-start;
  }

  .card {
    padding-right: 0px;
  }
}

@media (min-width: 1280px) {

  .card {
    flex-wrap: nowrap;
  }
}

.card-content-wrapper {
  margin-left: 0px;
  display: flex;
  width: 100%;
  flex-direction: column;
}

@media (min-width: 480px) {

  .card-content-wrapper {
    margin-left: 0.75rem;
  }
}

.card-content {
  justify-content: center;
  padding-top: 0.25rem;
}

@media (min-width: 480px) {

  .card-content {
    justify-content: flex-start;
  }
}

.card-title {
  justify-content: center;
}

@media (min-width: 480px) {

  .card-title {
    justify-content: flex-start;
  }

  .card-title, .card-content {
    margin-right: 1.5rem;
  }
}

.cta-wrapper {
  display: flex;
  justify-content: center;
}

@media (min-width: 480px) {

  .cta-wrapper {
    justify-content: flex-end;
  }
}

idb-heading {
  text-align: center;
  color: var(--blue-responsible-main);
}

img, svg {
  display: block;
  height: 117px;
  width: 117px;
  border-radius: 9999px;
  object-fit: cover;
  --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1);
  --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.image-profile--placeholder-image {
  display: block;
  height: 117px;
  width: 117px;
  border-radius: 9999px;
  background-color: var(--blue-responsible-lighten-3);
  object-fit: cover;
  --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1);
  --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.image-profile--placeholder-image svg{
    stroke:var(--blue-responsible-darken-2);
  }

section {
  display: flex;
  flex-direction: row;
}

.outline-shadow {
  --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1);
  --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

[slot='title'] {
  margin-bottom: 0px;
  margin-top: 1rem;
  text-align: center;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-bold);
  color: var(--blue-responsible-main);
}

@media (min-width: 480px) {

  [slot='title'] {
    text-align: left;
  }
}

[slot='content'] {
  text-align: center;
}

@media (min-width: 480px) {

  [slot='content'] {
    text-align: left;
  }
}

[slot='content'] p {
  margin: 0px;
}

[slot='content'] p {
  color: var(--blue-responsible-main);
}

[slot='content'] outline-link {
  display: block;
}

idb-button {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

:host(:not([inverted])) .outline-bg-light-blue {
  background-color: var(--blue-responsible-lighten-5);
}

:host(:not([inverted])) .outline-bg-blue {
  background-color: var(--blue-responsible-lighten-4);
}

:host(:not([inverted])) .outline-bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

:host(:not([inverted])) .outline-bg-green {
  background-color: var(--green-guarantee-lighten-4);
}

:host(:not([inverted])) .outline-bg-white {
  background-color: var(--neutral-white);
}

:host(:not([inverted])) .outline-bg-transparent {
  background-color: var(--neutral-transparent);
}

:host(:not([inverted])) .outline-bg-light-blue:hover, :host(:not([inverted])) .outline-bg-blue:hover, :host(:not([inverted])) .outline-bg-gray:hover, :host(:not([inverted])) .outline-bg-green:hover, :host(:not([inverted])) .outline-bg-white:hover, :host(:not([inverted])) .outline-bg-transparent:hover {
  background-color: var(--neutral-white);
}

:host([inverted]) .outline-bg-light-blue, :host([inverted]) .outline-bg-blue, :host([inverted]) .outline-bg-gray, :host([inverted]) .outline-bg-green, :host([inverted]) .outline-bg-white, :host([inverted]) .outline-bg-transparent {
  background-color: var(--neutral-white);
}

:host([inverted]) .outline-bg-light-blue:hover {
  background-color: var(--blue-responsible-lighten-5);
}

:host([inverted]) .outline-bg-blue:hover {
  background-color: var(--blue-responsible-lighten-4);
}

:host([inverted]) .outline-bg-gray:hover {
  background-color: var(--gray-professional-lighten-4);
}

:host([inverted]) .outline-bg-green:hover {
  background-color: var(--green-guarantee-lighten-4);
}

:host([inverted]) .outline-bg-white:hover {
  background-color: var(--neutral-white);
}

:host([inverted]) .outline-bg-transparent:hover {
  background-color: var(--neutral-transparent);
}

.outline-bg-light-blue, .outline-bg-blue, .outline-bg-gray, .outline-bg-green, .outline-bg-white, .outline-bg-transparent {
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}
`;